import { __rest } from '../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { useThemeColor } from './useThemeColor.js';

const ArrowCircleRightIcon = forwardRef((_a, ref) => {
    var { backgroundColor: propBackgroundColor = 'transparent' } = _a, props = __rest(_a, ["backgroundColor"]);
    const getColor = useThemeColor();
    const backgroundColor = getColor(propBackgroundColor);
    return (jsx(SvgIcon, Object.assign({}, props, { ref: ref }, { children: jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "22", height: "22", viewBox: "0 0 22 22" }, { children: jsxs("g", Object.assign({ "data-name": "Group 12814" }, { children: [jsx("path", { "data-name": "Path 18368", d: "M11 0A11 11 0 1 1 0 11 11 11 0 0 1 11 0z", fill: backgroundColor }), jsx("g", Object.assign({ "data-name": "Group 222" }, { children: jsx("path", { "data-name": "Path 232", d: "m15.883 135.273-3.114-3.1a.6.6 0 0 0-.841.845l2.091 2.081H5.6a.6.6 0 0 0 0 1.192h8.422l-2.091 2.081a.6.6 0 0 0 .841.845l3.114-3.1a.6.6 0 0 0-.003-.844z", transform: "translate(.472 -124.695)", fill: "currentColor" }) }))] })) })) })));
});

export { ArrowCircleRightIcon };
//# sourceMappingURL=ArrowCircleRightIcon.js.map
